import React from 'react';
import './customerOrders.scss';
import OrderDetail from './orderDetail.js';
import OrderInvoicing from './orderInvoicing.js';

import { useAuth } from  '../../contexts/auth'; 

import { TabPanel, Item } from 'devextreme-react/tab-panel';


import { useState, useEffect, useCallback  } from "react";

//import { Item} from 'devextreme-react/form';
//import { useCallback  } from "react";


export default function CustomerOrderDetail(props) {

  const { user } = useAuth(); 

  const [avanzamento, setAvanzamento] = useState({});

  const numberFormatter = new Intl.NumberFormat('it-IT', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  useEffect(() => {

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineCliente';
    var newUrl6 =  newServiceUrl6 + "/GetProgress/" + props.data.key; 

    const fetchData = async () => {
      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response6 = await fetch(newUrl6,requestOptions);
        const json6 = await response6.json();
        console.log(json6);
        setAvanzamento(json6);

      } catch (error) {
          console.log("error", error);
      }
    };
    fetchData();
}, []);


  function renderDetailTab() {
    return <OrderDetail myKey = {props.data.key} status = {props.data.data.statoId} />;
  }

  function renderInvoicingTab() {
    //console.log("K: " +props.data.key);
    return <OrderInvoicing myKey = {props.data.key} status = {props.data.data.statoId}/>;
  }

  const onTabSelectionChanged = useCallback((e) => {
      //notify("The button was clicked");
      ;
  }, []);

  function GetAvanzamento() {

    var totaleEvaso = "";
    var totaleIncassato = "";
    var perc = 0;
    var percFormat = "";
    var perc2 = 0;
    var percFormat2 = "";
    if (avanzamento[0] !== undefined){
        totaleEvaso = numberFormatter.format(avanzamento[0].totaleEvaso);
        totaleIncassato = numberFormatter.format(avanzamento[0].totaleIncassi);
        if (avanzamento[0].totaleOrdine > 0) {
            perc = (((100 * avanzamento[0].totaleEvaso) / avanzamento[0].totaleOrdine)).toFixed(0);
            percFormat = "(" + perc + "%)"
            perc2 = (((100 * avanzamento[0].totaleIncassi) / avanzamento[0].totaleOrdine)).toFixed(0);
            percFormat2 = "(" + perc2 + "%)"
      }
    }
      
    return  (
      <div>
        <div className={'mystats-container-small'}>
          <div div className={'mystats-data-small'}>Totale Evaso:&nbsp;<b>{totaleEvaso}</b>&nbsp;&nbsp;&nbsp;<b>{percFormat}</b></div>
          <div div className={'mystats-data-small'}>Totale Incassato:&nbsp;<b>{totaleIncassato}</b>&nbsp;&nbsp;&nbsp;<b>{percFormat2}</b></div>
        </div>
      </div>
    )
  };

  return (
  
    <div>

      <div className="offer-title" align="left" > 
        <h2>Ordine n° {props.data.data.numeroDoc} del {props.data.data.strDataDoc} -  {props.data.data.cliente}</h2>      
      </div>

      <GetAvanzamento></GetAvanzamento>
      <TabPanel    
        onSelectionChanged={onTabSelectionChanged}
      >
        <Item title="Dettaglio" render={renderDetailTab} />
        <Item title="Fatturazione" render={renderInvoicingTab} />
      </TabPanel>

    </div>   
  )
};